import React, { Component } from 'react';
import { Button, Form, InputGroup, FormText, FormControl } from 'react-bootstrap';
import { withRouter } from 'react-router-dom';

class Logout extends Component {

    constructor(props) {
        super(props);
        localStorage.setItem('login', null);
        localStorage.setItem('password', null);
        this.deleteCookie("session_hash");
        window.location.replace("/login");
    }

    setCookie(name, value, options = {}) {

        options = {
            path: '/',
            // при необходимости добавьте другие значения по умолчанию
            ...options
        };

        if (options.expires instanceof Date) {
            options.expires = options.expires.toUTCString();
        }

        let updatedCookie = encodeURIComponent(name) + "=" + encodeURIComponent(value);

        for (let optionKey in options) {
            updatedCookie += "; " + optionKey;
            let optionValue = options[optionKey];
            if (optionValue !== true) {
                updatedCookie += "=" + optionValue;
            }
        }

        document.cookie = updatedCookie;
    }

    deleteCookie(name) {
        this.setCookie(name, "", {
            'max-age': -1
        })
    }

    render() {
        return (
            <div>
            </div>
        );
    }
}

export default withRouter(Logout);


// WEBPACK FOOTER //
// ./src/components/Logout.js